import React from 'react';
import { getObjectValue } from '@utility/utills';
import ChecksCard from './ChecksCard/index';
import ChecksCardWithGroup from './ChecksCardWithGroup/index';

const TileView = props => {
  const {
    checks,
    selectedCheck,
    checksCount,
    setSelectedCheck,
    checkFilters,
    currentMode,
  } = props;
  const deviceInfo = getObjectValue(() =>
    JSON.parse(window.sessionStorage.getItem('deviceInfo'), false)
  );
  const isGroupingAllowed =
    deviceInfo?.deviceGroup?.fireBoardSettings?.groupedView;
  return (
    <>
      {isGroupingAllowed ? (
        <ChecksCardWithGroup
          checks={checks}
          selectedCheck={selectedCheck}
          checksCount={checksCount}
          setSelectedCheck={setSelectedCheck}
          isGroupingAllowed={isGroupingAllowed}
          checkFilters={checkFilters}
          currentMode={currentMode}
        />
      ) : (
        <ChecksCard
          checks={checks}
          selectedCheck={selectedCheck}
          checksCount={checksCount}
          setSelectedCheck={setSelectedCheck}
          currentMode={currentMode}
        />
      )}
    </>
  );
};

export default TileView;
